import { render, staticRenderFns } from "./TalentManagerWrapper.vue?vue&type=template&id=ff7b4df2&scoped=true"
import script from "./TalentManagerWrapper.vue?vue&type=script&lang=ts"
export * from "./TalentManagerWrapper.vue?vue&type=script&lang=ts"
import style0 from "./TalentManagerWrapper.vue?vue&type=style&index=0&id=ff7b4df2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7b4df2",
  null
  
)

export default component.exports